import { Context } from '@nuxt/types'

export default function ({ app }: Context) {
  app.nuxt.error = () => undefined
}
